import type { FC, MouseEventHandler } from "react";

import type { IntentSignalDomainsEventDto } from "app/pages/sales-intelligence/modules/company-analysis/types/signals";
import CollapsibleTrigger from "app/pages/sales-intelligence/pages/company-analysis/components/shared/section/CollapsibleTrigger/CollapsibleTrigger";

import { StyledCollapsibleSection, StyledExpandableList, StyledIntentTopicsList } from "./styles";

const DOMAINS_LIST_ITEMS_LIMIT = 3;

type Props = {
    signal: IntentSignalDomainsEventDto;
    onMouseEnter: MouseEventHandler<HTMLDivElement>;
};

const IntentSignalDomainsEventInfo: FC<Props> = ({ signal, onMouseEnter }) => {
    return (
        <StyledExpandableList
            limit={DOMAINS_LIST_ITEMS_LIMIT}
            itemsCount={signal.domains.length}
        >
            {signal.domains.map(({ domain, events }, index) => (
                <StyledCollapsibleSection
                    key={domain}
                    id={domain}
                    defaultIsExpanded={index === 0}
                    renderTrigger={(props) => <CollapsibleTrigger {...props}>{domain}</CollapsibleTrigger>}
                >
                    <StyledIntentTopicsList
                        signalEvents={events}
                        onMouseEnter={onMouseEnter}
                    />
                </StyledCollapsibleSection>
            ))}
        </StyledExpandableList>
    );
};

export default IntentSignalDomainsEventInfo;
